import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/internal-loads",
	lazy(() => import("./AdminInternalLoadsPage"))
);
